import { Button, Container, Row, Spinner } from "react-bootstrap";
import { Checkbox, Flex, Form, Input } from "antd";
import React, { useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import TextArea from "antd/es/input/TextArea";
import { Auth } from "../api/Auth";
import { closeSnackbar, enqueueSnackbar, SnackbarKey } from "notistack";
import { IconButton } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CheckboxChangeEvent } from "antd/es/checkbox";

const formLayout = {
  labelCol: {
    xs: 24,
    md: 24,
  },
  wrapperCol: {
    xs: 24,
    md: 24,
  },
};

export default function SupportForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const handleFormSubmit = useCallback((values: any) => {
    setLoading(true);
    Auth.sendEmail({
      sender: values.sender,
      name: values.name,
      surname: values.surname,
      country: values.country,
      receiver: "info@ecoburgus.it",
      title: values.title,
      text: values.text,
    }).then(
      () => {
        enqueueSnackbar({
          variant: "success",
          message:
            "Grazie per la tua segnalazione, ti risponderemo quanto prima",
          action: (key: SnackbarKey) => {
            return (
              <IconButton
                style={{ color: "white" }}
                onClick={() => closeSnackbar(key)}
              >
                <HighlightOffIcon />
              </IconButton>
            );
          },
        });
        setLoading(false);
      },
      () => {
        enqueueSnackbar({
          variant: "error",
          message: "Errore nell'invio della segnalazione, per favore riprova",
          action: (key: SnackbarKey) => {
            return (
              <IconButton
                style={{ color: "white" }}
                onClick={() => closeSnackbar(key)}
              >
                <HighlightOffIcon />
              </IconButton>
            );
          },
        });
        setLoading(false);
      }
    );
  }, []);

  return (
    <Container
      style={{ marginTop: 120 }}
      className="d-flex flex-column gap-3 pb-5 justify-content-center text-align-center align-items-center"
    >
      <img src={require("../assets/img/logo.png")} alt="Logo" />
      <h2 className="text-center mb-4">Contattaci</h2>
      <Form {...formLayout} form={form} onFinish={handleFormSubmit}>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="name"
            label="Nome"
            rules={[
              {
                required: true,
                message: "Devi inserire il tuo nome",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci il tuo nome..." />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            name="surname"
            label="Cognome"
            rules={[
              {
                required: true,
                message: "Devi inserire il tuo cognome",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci il tuo cognome..." />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            name="country"
            label="Comune"
            rules={[
              {
                required: true,
                message: "Devi inserire il Comune di riferimento",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Inserisci il Comune di riferimento..."
            />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            name="sender"
            label="Email"
            rules={[
              {
                required: true,
                message: "Devi inserire la tua email",
              },
              {
                type: "email",
                message: "Devi inserire un campo email valido",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci un indirizzo mail..." />
          </Form.Item>
        </Row>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="title"
            label="Titolo"
            rules={[
              {
                required: true,
                message: "Devi inserire un titolo per la tua segnalazione",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci un titolo..." />
          </Form.Item>
        </Row>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="text"
            label="Testo"
            rules={[
              {
                required: true,
                message: "Devi inserire un testo per la tua segnalazione",
              },
            ]}
          >
            <TextArea cols={24} rows={5} placeholder="Inserisci testo" />
          </Form.Item>
        </Row>
        <Flex gap={12} className="mb-3">
          <Checkbox
            checked={accepted}
            onChange={(e: CheckboxChangeEvent) => setAccepted(e.target.checked)}
          />
          <span>
            Dichiaro di aver letto e compreso le informazioni fornite dal
            Titolare del trattamento a norma del Regolamento UE n. 679/2016 -
            GDPR di cui alla sopra estesa informativa e consapevole, in
            particolare, che il trattamento dei propri dati ha le finalità di
            cui all'articolo 2 della sopra estesa informativa sottoscritta ai
            sensi dell'art. 13 del GDPR *
          </span>
        </Flex>
        <Button type="submit" variant="success" disabled={loading || !accepted}>
          {loading ? (
            <Spinner size="sm" />
          ) : (
            <FontAwesomeIcon icon={faCheckCircle} />
          )}
          <span className="ms-2">Invia</span>
        </Button>
      </Form>
    </Container>
  );
}
